<div class="mlc-card" *ngIf="isGuestUser">
  <div class="mlc-head">
    <ion-icon name="gift-outline" class="premium-icon-color"></ion-icon>
    <span class="fs-3 font600 primary-text-color">
      {{ 'booking_summary.login_title' | translate }}
    </span>
  </div>
  <p class="fs-3 grey-text mlc-body">
    {{ 'booking_summary.login_prompt' | translate }}
  </p>
  <ion-button
    mode="ios"
    expand="block"
    class="fs-4 font500 primary-btn"
    (click)="login()"
  >
    {{ 'booking_summary.login_cta' | translate }}
  </ion-button>
</div>
